import { createHttpClient } from "./http";

export class OrdemProducaoRepository {
	constructor() {
		this.axios = createHttpClient({ timeout: 300000 });
	}

	async save(data) {
		try {
			const result = await this.axios.post("ordem-producao", data, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
					"Content-Type": "application/json",
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.response?.data?.message || "Erro ao salvar ordem de produção.");
		}
	}

	async getAll(unidadeDistribuidoraId, search) {
		try {
			const params = {
				unidadeDistribuidoraId,
			};

			if (search) {
				params.search = search;
			}

			const result = await this.axios.get("ordem-producao", {
				params,
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.message || "Erro ao listar ordens de produção.");
		}
	}

	// Produtos de OPs anteriores com saldo, para as etapas que solicitam produto.
	// excluirOrdemId tira a propria OP da lista quando se esta editando.
	async getProdutosDisponiveis(unidadeDistribuidoraId, excluirOrdemId) {
		try {
			const params = {
				unidadeDistribuidoraId,
			};

			if (excluirOrdemId) {
				params.excluirOrdemId = excluirOrdemId;
			}

			const result = await this.axios.get("ordem-producao/produtos-disponiveis", {
				params,
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(
				error.response?.data?.message || "Erro ao buscar produtos disponíveis."
			);
		}
	}

	async getById(id) {
		try {
			const result = await this.axios.get(`ordem-producao/${id}`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.message || "Erro ao buscar ordem de produção.");
		}
	}

	async delete(id) {
		try {
			const result = await this.axios.delete(`ordem-producao/${id}`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.response?.data?.message || "Erro ao excluir ordem de produção.");
		}
	}
}
